import { render, staticRenderFns } from "./returns.vue?vue&type=template&id=cf890a18&"
import script from "./returns.js?vue&type=script&lang=js&"
export * from "./returns.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports